// JobTypeOptions.js
const JobTypeOptions = [
  "Full Time",
  "Part Time",
  "Contract",
  "Internship",
  "Temporary",
  "Freelance",
  "Work From Home",
  "Remote",
  "On-site",
  "Hybrid"
];

export default JobTypeOptions;
